<template>
  <v-app class="pldc"
    style="height: 100%; max-width: 450px;"
    :class="{'d-flex': true, 'flex-column': true, on_desktop: $vuetify.breakpoint.smAndUp }"
  >
    <div
      class="d-flex flex-column align-center flex-grow-0 py-2"
      style="background-color: #004056;"
    >
      <img src="@/assets/logo_white_transparent_background.png" height="27px">
    </div>  

    <v-main class="flex-grow-1 grey lighten-3">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'WizardLayout',
}
</script>

<style>
  html, body {
    height: 100%;
  }

  .v-application--wrap {
    min-height: 100vh !important;
    min-height: -webkit-fill-available !important;
  }
</style>